module.exports = __webpack_public_path__ + "static/media/wx@3x.b8d2838b.png";